const getDefaultState = () => {
  return {
    userInfo: null,
    companyInfo: "",
    devList: [],
    devDetails: {},
    userInfoDetails: {},
  };
};

const state = getDefaultState();

const mutations = {
  setDevList(state, data) {
    state.devList = data;
  },
  setDevDetails(state, data) {
    state.devDetails = data;
  },
  setCompanyInfo(state, data) {
    state.companyInfo = data;
  },
  setUserInfo(state, data) {
    localStorage.setItem("userInfo", JSON.stringify(data));
    state.userInfo = data;
  },
  setUserInfoDetails(state, data) {
    state.userInfoDetails = data;
  },
  clearUserInfo(state) {
    localStorage.removeItem("userInfo");
    state.userInfo = "";
    state.devList = [];
    state.devDetails = {};
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
